import { useState, useEffect } from 'react';
import { Shop } from '@pdqdev/pdq-shared/dist/entities/Shop';
import { useAppContext } from '@app/react-common/AppContext';

const useShop = (): Shop => {
  const { shop$ } = useAppContext();
  const [shop, setShop] = useState<Shop>(null);

  useEffect(() => {
    const subscription = shop$.subscribe((shop) => {
      if (shop) {
        setShop(shop);
      }
    });
    return () => {
      subscription.unsubscribe();
    };
  }, [shop$]);

  return shop;
};

export default useShop;
